/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.playback.getVideoPlaylist";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"track":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"start":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"end":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"sid":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.payload("*/*");

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get an HLS CMAF playlist for a video. Returns a master playlist when `track` is omitted, or a single-track media playlist when `track` is supplied. The playlist references each segment + per-track init segment via getVideoBlob, addressed by content hash. The `uri` is an AT-URI pointing at a playable record — today only place.stream.video records are supported, but the surface is collection-agnostic so other record types can join later. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ["VideoNotFound","TrackNotFound","BlobNotFound","UnsupportedCollection"]);

export { main };

export const $lxm = $nsid;
